import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { Map, fromJS } from 'immutable';

const INIT_STATE = Map({
    activeSelection: ''
})

function setActiveSelection(state, action){
    return state.set('activeSelection', action.payload.activeSelectionID);
}


function settingsReducer(state = INIT_STATE, action) {
    
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.SETTINGS_SET_ACTIVE_SELECTION:
            return setActiveSelection(state, action);
        default:
            return state;
    }
}

export default settingsReducer;